/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
export interface EnvironmentInfo {
    STARTREE_DEPLOYMENT_TYPE: EnvironmentDeploymentType;
    STARTREE_ENV: string;
    STARTREE_ENV_ID: string;
    STARTREE_ORG_ID: string;
    STARTREE_ORG: string;
}

export enum EnvironmentDeploymentType {
    STARTREE = "startree",
    BYOC = "byoc",
}
